import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70c2db7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deposit-customer-page" }
const _hoisted_2 = {
  class: "deposit-customer-page__statistics",
  "aria-label": "定金客户统计"
}
const _hoisted_3 = { class: "deposit-customer-page__customer" }

import { computed, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { Download } from '@element-plus/icons-vue'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import {
  depositCustomerSearchItems,
  depositCustomerTableColumns
} from './deposit-customer.config'
import {
  exportDepositCustomers,
  fetchDepositCustomerPage
} from './deposit-customer.service'
import type {
  DepositCustomerFilters,
  DepositCustomerStatistics
} from './deposit-customer.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositCustomer',
  setup(__props) {

const canList = usePermission('realtimeDepositCustomer', 'list')
const canDownload = usePermission('realtimeDepositCustomer', 'download')

const emptyStatistics = (): DepositCustomerStatistics => ({
  totalDepositCustomerCount: 0,
  unpaidBalanceCustomerCount: 0,
  unpaidBalanceRate: 0
})

const statistics = ref(emptyStatistics())
const exporting = ref(false)

const createFilters = (): DepositCustomerFilters => ({
  customerKeyword: '',
  unionid: '',
  businessSourceName: '',
  deptName: '',
  empName: '',
  orderTime: [
    dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
  ],
  paymentChannel: '',
  refunded: '',
  balanceStatus: '',
  productName: '',
  status: ''
})

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  lastSuccessfulQuery,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters,
  fetchPage: async (query, signal) => {
    const result = await fetchDepositCustomerPage(query, signal)
    statistics.value = result.statistics
    return result
  }
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

function runQuery(action: () => Promise<boolean>) {
  return canList ? action() : Promise.resolve(false)
}

function handlePageChange(value: number) {
  return runQuery(() => changePage(value))
}

function handlePageSizeChange(value: number) {
  return runQuery(() => changePageSize(value))
}

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

async function download() {
  if (!lastSuccessfulQuery.value) return

  exporting.value = true
  try {
    saveBlob(
      await exportDepositCustomers(lastSuccessfulQuery.value),
      '实时定金客户.xlsx'
    )
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '导出失败')
  } finally {
    exporting.value = false
  }
}

onMounted(() => {
  if (canList) load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: _unref(depositCustomerSearchItems),
      loading: _unref(loading),
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (runQuery(_unref(search)))),
      onReset: _cache[1] || (_cache[1] = ($event: any) => (runQuery(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(" 已交定金客户总数： "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.totalDepositCustomerCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode(" 未交尾款客户数： "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.unpaidBalanceCustomerCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode(" 未交尾款客户占比： "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.unpaidBalanceRate) + "%", 1)
      ])
    ]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "row-key": "depositPaymentId",
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(depositCustomerTableColumns),
      onPageChange: handlePageChange,
      onPageSizeChange: handlePageSizeChange,
      onRetry: _cache[2] || (_cache[2] = ($event: any) => (runQuery(_unref(refresh))))
    }, {
      title: _withCtx(() => [
        _createTextVNode("定金客户列表")
      ]),
      actions: _withCtx(() => [
        (_unref(canDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: exporting.value,
              disabled: _unref(loading) || !_unref(lastSuccessfulQuery),
              onClick: download
            }, {
              default: _withCtx(() => [
                (!exporting.value)
                  ? (_openBlock(), _createBlock(_unref(Download), {
                      key: 0,
                      class: "deposit-customer-page__button-icon",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" 导出 ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      customer: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 48,
            src: row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(row.customerName || '-'), 1)
        ])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns"])
  ]))
}
}

})